import React from 'react';
import Input from '../Input/Input.js';
import standardInput from '../hocs/StandardInputHOC.js';
import { jsx as _jsx } from "react/jsx-runtime";
function StandardZipInput(props) {
  return /*#__PURE__*/_jsx(Input, {
    "data-cmp": "standardZipInput",
    type: "tel",
    mask: [/\d/, /\d/, /\d/, /\d/, /\d/],
    placeholderChar: " ",
    guide: false,
    ...props
  });
}
export default /* #__PURE__ */standardInput(StandardZipInput, {
  validations: {
    minLength: 5,
    maxLength: 5,
    matchRegexp: /\d\d\d\d\d/
  },
  validationError: 'Enter a valid ZIP Code',
  validationErrors: {
    isDefaultRequiredValue: 'Enter your ZIP Code'
  }
});